import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  hideRecommendHandles,
  isModalVisible,
  setDismissed,
  setDismissedAndContinue
} from './RecommendHandles';

import { selectGroup } from 'ducks/products';
import { usePlannerConfig } from 'contexts/plannerConfig';
import styled from 'styled-components';
import handle from './handle.jpeg';
import Body from 'ui/Typography/Body';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useIntl } from 'react-intl';
import { reportHandlePromptAddHandles } from 'analytics/reporters';
import { useAppDispatch } from 'ducks/hooks';
import { showDoors } from 'ducks/layout';
import Modal, { ModalFooter, ModalHeader, Sheets } from '@ingka/modal';
import Button from '@ingka/button';
import Title from 'ui/Typography/Title';
import media from 'ui/media';

const ContentWrapper = styled.div`
  padding: 0 2.5rem 1rem;
  ${media.mobile`
    padding: 0 1.5rem 1rem;
  `}
`;

const Image = styled.img`
  width: 329px;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 5rem;
`;

const TitleWrapper = styled.div`
  ${media.mobile`
    width: 100%;
    padding: 0.5rem 0;
  `}
`;

const RecommendHandlesSheet = () => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  const {
    plannerConfig: { productGroups }
  } = usePlannerConfig();

  const modalVisible = useSelector(isModalVisible);

  useEffect(() => {
    if (modalVisible) dispatch(showDoors());
  }, [dispatch, modalVisible]);

  const onClose = () => {
    dispatch(setDismissed(true));
    dispatch(hideRecommendHandles());
  };

  const onAddHandles = () => {
    const handlesProductGroup = productGroups.find(p => p.id === 'handles');
    dispatch(hideRecommendHandles());
    dispatch(setDismissed(true));
    dispatch(selectGroup(handlesProductGroup?.id || ''));
    reportHandlePromptAddHandles();
  };

  const onContinueWithoutHandles = () => {
    dispatch(setDismissed(true));
    dispatch(hideRecommendHandles());
    dispatch(setDismissedAndContinue(true));
  };

  return (
    <Modal
      id="recommend-handles-sheet"
      data-testid="recommend-handles-sheet"
      visible={modalVisible}
      escapable={true}
      handleCloseBtn={onClose}
      style={{ zIndex: 2000 }}
    >
      <Sheets
        aria-labelledby="recommend-handles-sheet"
        id="RecommendHandlesSheet"
        title={formatMessage({ id: 'storageone.cantOpenDesignModalTitle' })}
        header={
          <ModalHeader
            data-testid="modal-header"
            ariaCloseTxt={formatMessage({ id: 'storageone.closeButton' })}
          />
        }
        footer={
          <ModalFooter data-testid="recommend-handles-sheet-footer-buttons" stacked renderBorder>
            <Button
              text={formatMessage({ id: 'storageone.continueWithoutHandles' })}
              onClick={onContinueWithoutHandles}
              type="secondary"
              data-testid="continue-without-handles-button"
            ></Button>
            <Button
              text={formatMessage({ id: 'storageone.addHandles' })}
              onClick={onAddHandles}
              type="primary"
              data-testid="continue-with-handles-button"
            ></Button>
          </ModalFooter>
        }
      >
        <ContentWrapper>
          <TitleWrapper>
            <Title type={ThemeFontStyleTypeEnum.headingMedium} mb="md">
              {formatMessage({ id: 'storageone.dontForgetHandlesTitle' })}
            </Title>
          </TitleWrapper>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium} mb="xxxl">
            {formatMessage({ id: 'storageone.dontForgetHandlesDescription' })}
          </Body>
          <ImageWrapper>
            <Image
              src={handle}
              alt={formatMessage({ id: 'storageone.dontForgetHanldesImageDescription' })}
            />
          </ImageWrapper>
        </ContentWrapper>
      </Sheets>
    </Modal>
  );
};

export default RecommendHandlesSheet;
